'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nodePalette = exports.grayPalette = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
}; // Quid UI patterns
// https://quid.invisionapp.com/d/main#/console/11011818/233087591/preview


var _color = require('color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var grayPalette = exports.grayPalette = {
  white: '#FFFFFF',
  gray1: '#E3E6E8',
  gray2: '#C7CCD1',
  gray3: '#909BA3',
  gray4: '#6D7983',
  gray5: '#49535A',
  gray6: '#2E3338',
  gray7: '#1B1F21',
  black: '#121212'
};
var nodePalette = exports.nodePalette = {
  aqua: '#1ED7D1',
  coral: '#F04E53',
  lime: '#87C445',
  purple: '#A8499A',
  yellow: '#FFCE03',
  teal: '#3C8790',
  peach: '#F4A467',
  red: '#E61E27',
  rose: '#BF8092',
  green: '#039849',
  sky: '#A6DEF3',
  brown: '#9A6051',
  lemon: '#EAE962',
  margenta: '#B22264',
  tan: '#C1966B',
  emerald: '#00804F',
  lilac: '#9581BC',
  orange: '#F9621E',
  blue: '#2E56BC',
  pink: '#D72E8E'
};
var brandPalette = {
  quidTeal: '#00a7b8',
  selected: '#00c1bb',
  highlighted: (0, _color2.default)('#00c1bb').alpha(0.6).string(),
  link: '#28beb8'
};

var colors = _extends({}, grayPalette, nodePalette, brandPalette);

exports.default = colors;